import { render, staticRenderFns } from "./AccrualsFormWizard.vue?vue&type=template&id=24b9d1dc&scoped=true&"
import script from "./AccrualsFormWizard.vue?vue&type=script&lang=ts&"
export * from "./AccrualsFormWizard.vue?vue&type=script&lang=ts&"
import style0 from "./AccrualsFormWizard.vue?vue&type=style&index=0&id=24b9d1dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b9d1dc",
  null
  
)

export default component.exports